import {isNil} from 'ramda';

import {invalidateOnSuccess, metadaApi} from '@dms/api/base';

import {getServiceOrderImportInvalidationTags} from '../utils/getServiceOrderImportInvalidationTags';
import {
  PostIntegrationsForXentryLinkApiResponse,
  PostIntegrationsForXentryLinkApiArg,
  PostIntegrationsForXentryUnlinkApiResponse,
  PostIntegrationsForXentryUnlinkApiArg,
  PostAvailableXentryOrdersApiResponse,
  PostAvailableXentryOrdersApiArg,
  GetServiceCaseIntegrationsApiResponse,
  GetServiceCaseIntegrationsApiArg,
  PostServiceOrderAudatexTaskCalculationsApiResponse,
  PostServiceOrderAudatexTaskCalculationsApiArg,
  PostServiceOrderMyClaimCalculationsApiResponse,
  PostServiceOrderMyClaimCalculationsApiArg,
  PostIntegrationsForXentryLinkApiResponseSchema,
  PostIntegrationsForXentryLinkApiArgSchema,
  PostIntegrationsForXentryUnlinkApiResponseSchema,
  PostIntegrationsForXentryUnlinkApiArgSchema,
  PostAvailableXentryOrdersApiResponseSchema,
  PostAvailableXentryOrdersApiArgSchema,
  GetServiceCaseIntegrationsApiResponseSchema,
  GetServiceCaseIntegrationsApiArgSchema,
  PostServiceOrderAudatexTaskCalculationsApiResponseSchema,
  PostServiceOrderAudatexTaskCalculationsApiArgSchema,
  PostServiceOrderMyClaimCalculationsApiResponseSchema,
  PostServiceOrderMyClaimCalculationsApiArgSchema,
  PostServiceCaseIntegrationsXentryOrderManualCreationApiResponse,
  PostServiceCaseIntegrationsXentryOrderManualCreationApiArg,
  PostServiceCaseIntegrationsXentryOrderManualCreationApiResponseSchema,
  PostServiceCaseIntegrationsXentryOrderManualCreationApiArgSchema,
  PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponse,
  PostServiceCaseIntegrationsXentryOrderSynchronizationApiArg,
  PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponseSchema,
  PostServiceCaseIntegrationsXentryOrderSynchronizationApiArgSchema,
  GetAudatexCalculationsUserSettingsApiArg,
  GetAudatexCalculationsUserSettingsApiResponse,
  GetMyClaimCalculationsUserSettingsApiArg,
  GetMyClaimCalculationsUserSettingsApiResponse,
  GetMyClaimCalculationsUserSettingsApiResponseSchema,
  GetMyClaimCalculationsUserSettingsApiArgSchema,
  GetAudatexCalculationsUserSettingsApiResponseSchema,
  GetAudatexCalculationsUserSettingsApiArgSchema,
  GetServiceCaseIntegrationsClaraVehicleDetailsApiResponse,
  GetServiceCaseIntegrationsClaraVehicleDetailsApiArg,
  GetServiceCaseIntegrationsClaraClaimDetailApiArg,
  GetServiceCaseIntegrationsClaraClaimDetailApiResponse,
  GetServiceCaseIntegrationsClaraClaimApiArg,
  GetServiceCaseIntegrationsClaraClaimApiResponse,
  GetServiceCaseIntegrationsClaraClaimApiResponseSchema,
  GetServiceCaseIntegrationsClaraClaimApiArgSchema,
  GetServiceCaseIntegrationsClaraClaimDetailApiArgSchema,
  GetServiceCaseIntegrationsClaraClaimDetailApiResponseSchema,
  PostServiceCaseIntegrationsClaraClaimApiArg,
  PostServiceCaseIntegrationsClaraClaimApiResponse,
  PostServiceCaseIntegrationsClaraClaimApiArgSchema,
  PostServiceCaseIntegrationsClaraClaimApiResponseSchema,
  GetServiceOrderIntegrationClaraInformationApiArgSchema,
  GetServiceOrderIntegrationClaraInformationApiArg,
  GetServiceOrderIntegrationClaraInformationApiResponse,
  GetServiceOrderIntegrationClaraInformationApiResponseSchema,
  PatchServiceOrderIntegrationClaraInformationApiArgSchema,
  PatchServiceOrderIntegrationClaraInformationApiResponseSchema,
  PatchServiceOrderIntegrationClaraInformationApiArg,
  PatchServiceOrderIntegrationClaraInformationApiResponse,
  GetServiceWorkItemIntegrationClaraInformationApiArgSchema,
  GetServiceWorkItemIntegrationClaraInformationApiResponseSchema,
  GetServiceWorkItemIntegrationClaraInformationApiArg,
  GetServiceWorkItemIntegrationClaraInformationApiResponse,
  PatchServiceWorkItemIntegrationClaraInformationApiResponseSchema,
  PatchServiceWorkItemIntegrationClaraInformationApiArg,
  PatchServiceWorkItemIntegrationClaraInformationApiResponse,
  PatchServiceWorkItemIntegrationClaraInformationApiArgSchema,
  GetServiceMaterialItemIntegrationClaraInformationApiArgSchema,
  GetServiceMaterialItemIntegrationClaraInformationApiResponseSchema,
  GetServiceMaterialItemIntegrationClaraInformationApiArg,
  GetServiceMaterialItemIntegrationClaraInformationApiResponse,
  PatchServiceMaterialItemIntegrationClaraInformationApiResponseSchema,
  PatchServiceMaterialItemIntegrationClaraInformationApiArgSchema,
  PatchServiceMaterialItemIntegrationClaraInformationApiResponse,
  PatchServiceMaterialItemIntegrationClaraInformationApiArg,
  GetServiceJobIntegrationXentryInformationApiResponse,
  GetServiceJobIntegrationXentryInformationApiArg,
  GetServiceJobIntegrationXentryInformationApiResponseSchema,
  GetServiceJobIntegrationXentryInformationApiArgSchema,
  PatchServiceJobIntegrationXentryInformationApiResponse,
  PatchServiceJobIntegrationXentryInformationApiArg,
  PatchServiceJobIntegrationXentryInformationApiResponseSchema,
  PatchServiceJobIntegrationXentryInformationApiArgSchema,
  GetIntegrationCustomerApiResponse,
  GetIntegrationCustomerApiArg,
  GetIntegrationCustomerApiResponseSchema,
  GetIntegrationCustomerApiArgSchema,
  GetServiceCaseIntegrationsXentrySynchronizationStatusApiResponse,
  GetServiceCaseIntegrationsXentrySynchronizationStatusApiArg,
  GetServiceCaseIntegrationsXentrySynchronizationStatusApiResponseSchema,
  GetServiceCaseIntegrationsXentrySynchronizationStatusApiArgSchema,
  GetServiceCaseIntegrationsEvaClaimDetailApiResponse,
  GetServiceCaseIntegrationsEvaClaimDetailApiArg,
  PostServiceCaseIntegrationsEvaClaimExportApiArg,
  PostServiceCaseIntegrationsEvaClaimExportApiResponse,
  GetServiceCaseIntegrationsEvaClaimDetailApiArgSchema,
  GetServiceCaseIntegrationsEvaClaimDetailApiResponseSchema,
  PostServiceCaseIntegrationsEvaClaimExportApiArgSchema,
  PostServiceCaseIntegrationsEvaClaimExportApiResponseSchema,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiArg,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponseSchema,
  GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiArgSchema,
  PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
  PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiArg,
  PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponseSchema,
  PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiArgSchema,
  GetServiceOrderIntegrationsMazdaAdditionalInformationApiResponse,
  GetServiceOrderIntegrationsMazdaAdditionalInformationApiArg,
  GetServiceOrderIntegrationsMazdaAdditionalInformationApiResponseSchema,
  GetServiceOrderIntegrationsMazdaAdditionalInformationApiArgSchema,
  PatchServiceOrderIntegrationsMazdaAdditionalInformationApiResponse,
  PatchServiceOrderIntegrationsMazdaAdditionalInformationApiArg,
  PatchServiceOrderIntegrationsMazdaAdditionalInformationApiResponseSchema,
  PatchServiceOrderIntegrationsMazdaAdditionalInformationApiArgSchema,
  GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponse,
  GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiArg,
  GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponseSchema,
  GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiArgSchema,
  PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponse,
  PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiArg,
  PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponseSchema,
  PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiArgSchema,
  GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiResponse,
  GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiArg,
  GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiResponseSchema,
  GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiArgSchema,
  GetServiceOrderIntegrationsMazdaPreauthorizationApiResponse,
  GetServiceOrderIntegrationsMazdaPreauthorizationApiArg,
  GetServiceOrderIntegrationsMazdaPreauthorizationApiResponseSchema,
  GetServiceOrderIntegrationsMazdaPreauthorizationApiArgSchema,
  PutServiceOrderIntegrationsMazdaPreauthorizationApiResponse,
  PutServiceOrderIntegrationsMazdaPreauthorizationApiArg,
  PutServiceOrderIntegrationsMazdaPreauthorizationApiResponseSchema,
  PutServiceOrderIntegrationsMazdaPreauthorizationApiArgSchema,
  PostServiceOrderIntegrationsMazdaPreauthorizationSendApiResponse,
  PostServiceOrderIntegrationsMazdaPreauthorizationSendApiArg,
  PostServiceOrderIntegrationsMazdaPreauthorizationSendApiResponseSchema,
  PostServiceOrderIntegrationsMazdaPreauthorizationSendApiArgSchema,
  GetServiceOrderIntegrationsMazdaClaimApiResponse,
  GetServiceOrderIntegrationsMazdaClaimApiArg,
  GetServiceOrderIntegrationsMazdaClaimApiResponseSchema,
  GetServiceOrderIntegrationsMazdaClaimApiArgSchema,
  PutServiceOrderIntegrationsMazdaClaimApiResponse,
  PutServiceOrderIntegrationsMazdaClaimApiArg,
  PutServiceOrderIntegrationsMazdaClaimApiResponseSchema,
  PutServiceOrderIntegrationsMazdaClaimApiArgSchema,
  PostServiceOrderIntegrationsMazdaClaimSendApiResponse,
  PostServiceOrderIntegrationsMazdaClaimSendApiArg,
  PostServiceOrderIntegrationsMazdaClaimSendApiResponseSchema,
  PostServiceOrderIntegrationsMazdaClaimSendApiArgSchema,
  GetServiceOrderIntegrationsMazdaClaimDetailApiResponse,
  GetServiceOrderIntegrationsMazdaClaimDetailApiArg,
  GetServiceOrderIntegrationsMazdaClaimDetailApiResponseSchema,
  GetServiceOrderIntegrationsMazdaClaimDetailApiArgSchema,
  GetVehicleServiceChecklistsApiResponse,
  GetVehicleServiceChecklistsApiArg,
  GetVehicleServiceChecklistsApiResponseSchema,
  GetVehicleServiceChecklistsApiArgSchema,
  PostVehicleServiceChecklistApiResponse,
  PostVehicleServiceChecklistApiArg,
  PostVehicleServiceChecklistApiResponseSchema,
  PostVehicleServiceChecklistApiArgSchema,
} from './types';

const metadaWorkshopIntegrationApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postIntegrationsForXentryLink: build.mutation<
      PostIntegrationsForXentryLinkApiResponse,
      PostIntegrationsForXentryLinkApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/xentry-order-link`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        {type: 'serviceJobs', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        'serviceOrderJobs',
      ],
      extraOptions: {
        responseSchema: PostIntegrationsForXentryLinkApiResponseSchema,
        requestSchema: PostIntegrationsForXentryLinkApiArgSchema,
      },
    }),
    postIntegrationsForXentryUnlink: build.mutation<
      PostIntegrationsForXentryUnlinkApiResponse,
      PostIntegrationsForXentryUnlinkApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/xentry-order-unlink`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        {type: 'serviceJobs', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        'serviceOrderJobs',
      ],
      extraOptions: {
        responseSchema: PostIntegrationsForXentryUnlinkApiResponseSchema,
        requestSchema: PostIntegrationsForXentryUnlinkApiArgSchema,
      },
    }),
    postAvailableXentryOrders: build.mutation<
      PostAvailableXentryOrdersApiResponse,
      PostAvailableXentryOrdersApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/xentry-orders`,
        method: 'POST',
        queryArg,
      }),
      extraOptions: {
        responseSchema: PostAvailableXentryOrdersApiResponseSchema,
        requestSchema: PostAvailableXentryOrdersApiArgSchema,
      },
    }),
    getServiceCaseIntegrations: build.query<
      GetServiceCaseIntegrationsApiResponse,
      GetServiceCaseIntegrationsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integrations`,
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsApiArgSchema,
      },
      providesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
      ],
    }),
    postServiceOrderAudatexTaskCalculations: build.mutation<
      PostServiceOrderAudatexTaskCalculationsApiResponse,
      PostServiceOrderAudatexTaskCalculationsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/audatex-task-calculations`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        ...getServiceOrderImportInvalidationTags(queryArg),
        'audatexCalculationsUserSettings',
      ],
      extraOptions: {
        responseSchema: PostServiceOrderAudatexTaskCalculationsApiResponseSchema,
        requestSchema: PostServiceOrderAudatexTaskCalculationsApiArgSchema,
      },
    }),
    postServiceOrderMyClaimCalculations: build.mutation<
      PostServiceOrderMyClaimCalculationsApiResponse,
      PostServiceOrderMyClaimCalculationsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/myclaim-calculations`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        ...getServiceOrderImportInvalidationTags(queryArg),
        'myClaimCalculationsUserSettings',
      ],
      extraOptions: {
        responseSchema: PostServiceOrderMyClaimCalculationsApiResponseSchema,
        requestSchema: PostServiceOrderMyClaimCalculationsApiArgSchema,
      },
    }),
    postServiceCaseIntegrationsXentryOrderManualCreation: build.mutation<
      PostServiceCaseIntegrationsXentryOrderManualCreationApiResponse,
      PostServiceCaseIntegrationsXentryOrderManualCreationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/xentry-order-manual-creation`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        {type: 'serviceJobs', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        'serviceOrderJobs',
      ],
      extraOptions: {
        responseSchema: PostServiceCaseIntegrationsXentryOrderManualCreationApiResponseSchema,
        requestSchema: PostServiceCaseIntegrationsXentryOrderManualCreationApiArgSchema,
      },
    }),
    postServiceCaseIntegrationsXentryOrderSynchronizationApi: build.mutation<
      PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponse,
      PostServiceCaseIntegrationsXentryOrderSynchronizationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v2/service-case/${queryArg.serviceCaseId}/integration/xentry-order-synchronize`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        {type: 'checkIn', id: queryArg.serviceCaseId},
        {type: 'handOver', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
        'serviceOrder',
        'serviceOrderJobs',
        'serviceOrderTotalAmount',
        {type: 'serviceCaseTotalAmount', id: queryArg.serviceCaseId},
        'serviceOrderJobTotalAmount',
        'orderProfitability',
        'serviceOrderJobs',
        'checkout',
        'afsCheckout',
        'afsPaymentsList',
        'serviceJobActions',
        {type: 'serviceActions', id: queryArg.serviceCaseId},
        'orderActions',
        'serviceOrderCheckoutRestriction',
      ],
      extraOptions: {
        responseSchema: PostServiceCaseIntegrationsXentryOrderSynchronizationApiResponseSchema,
        requestSchema: PostServiceCaseIntegrationsXentryOrderSynchronizationApiArgSchema,
      },
    }),
    getAudatexCalculationsUserSettings: build.query<
      GetAudatexCalculationsUserSettingsApiResponse,
      GetAudatexCalculationsUserSettingsApiArg
    >({
      query: () => ({
        url: `/service/v1/integration/audatex-calculations-user-settings`,
      }),
      providesTags: () => [{type: 'audatexCalculationsUserSettings'}],
      extraOptions: {
        responseSchema: GetAudatexCalculationsUserSettingsApiResponseSchema,
        requestSchema: GetAudatexCalculationsUserSettingsApiArgSchema,
      },
    }),
    getMyClaimCalculationsUserSettings: build.query<
      GetMyClaimCalculationsUserSettingsApiResponse,
      GetMyClaimCalculationsUserSettingsApiArg
    >({
      query: () => ({
        url: `/service/v1/integration/myclaim-calculations-user-settings`,
      }),
      providesTags: () => ['myClaimCalculationsUserSettings'],
      extraOptions: {
        responseSchema: GetMyClaimCalculationsUserSettingsApiResponseSchema,
        requestSchema: GetMyClaimCalculationsUserSettingsApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsClaraVehicleDetails: build.query<
      GetServiceCaseIntegrationsClaraVehicleDetailsApiResponse,
      GetServiceCaseIntegrationsClaraVehicleDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/clara-vehicle-info`,
      }),
    }),
    getServiceCaseIntegrationsClaraClaim: build.query<
      GetServiceCaseIntegrationsClaraClaimApiResponse,
      GetServiceCaseIntegrationsClaraClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-claim`,
      }),
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsClaraClaimApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsClaraClaimApiArgSchema,
      },
    }),
    postServiceCaseIntegrationsClaraClaim: build.mutation<
      PostServiceCaseIntegrationsClaraClaimApiResponse,
      PostServiceCaseIntegrationsClaraClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-claim`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: PostServiceCaseIntegrationsClaraClaimApiResponseSchema,
        requestSchema: PostServiceCaseIntegrationsClaraClaimApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsClaraClaimDetail: build.query<
      GetServiceCaseIntegrationsClaraClaimDetailApiResponse,
      GetServiceCaseIntegrationsClaraClaimDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-claim-detail`,
      }),
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsClaraClaimDetailApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsClaraClaimDetailApiArgSchema,
      },
    }),
    getServiceOrderIntegrationClaraInformation: build.query<
      GetServiceOrderIntegrationClaraInformationApiResponse,
      GetServiceOrderIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-additional-information`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: GetServiceOrderIntegrationClaraInformationApiResponseSchema,
        requestSchema: GetServiceOrderIntegrationClaraInformationApiArgSchema,
      },
    }),
    patchServiceOrderIntegrationClaraInformation: build.mutation<
      PatchServiceOrderIntegrationClaraInformationApiResponse,
      PatchServiceOrderIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/clara-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
      ],
      extraOptions: {
        responseSchema: PatchServiceOrderIntegrationClaraInformationApiResponseSchema,
        requestSchema: PatchServiceOrderIntegrationClaraInformationApiArgSchema,
      },
    }),
    getServiceWorkItemIntegrationClaraInformation: build.query<
      GetServiceWorkItemIntegrationClaraInformationApiResponse,
      GetServiceWorkItemIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-work/${queryArg.serviceItemId}/integration/clara-additional-information`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'workItemIntegration', id: queryArg.serviceItemId},
      ],
      extraOptions: {
        responseSchema: GetServiceWorkItemIntegrationClaraInformationApiResponseSchema,
        requestSchema: GetServiceWorkItemIntegrationClaraInformationApiArgSchema,
      },
    }),
    patchServiceWorkItemIntegrationClaraInformation: build.mutation<
      PatchServiceWorkItemIntegrationClaraInformationApiResponse,
      PatchServiceWorkItemIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-work/${queryArg.serviceItemId}/integration/clara-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'workItemIntegration', id: queryArg.serviceItemId},
      ],
      extraOptions: {
        responseSchema: PatchServiceWorkItemIntegrationClaraInformationApiResponseSchema,
        requestSchema: PatchServiceWorkItemIntegrationClaraInformationApiArgSchema,
      },
    }),
    getServiceMaterialItemIntegrationClaraInformation: build.query<
      GetServiceMaterialItemIntegrationClaraInformationApiResponse,
      GetServiceMaterialItemIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-material/${queryArg.serviceItemId}/integration/clara-additional-information`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'materialItemIntegration', id: queryArg.serviceItemId},
      ],
      extraOptions: {
        responseSchema: GetServiceMaterialItemIntegrationClaraInformationApiResponseSchema,
        requestSchema: GetServiceMaterialItemIntegrationClaraInformationApiArgSchema,
      },
    }),
    patchServiceMaterialItemIntegrationClaraInformation: build.mutation<
      PatchServiceMaterialItemIntegrationClaraInformationApiResponse,
      PatchServiceMaterialItemIntegrationClaraInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-material/${queryArg.serviceItemId}/integration/clara-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'materialItemIntegration', id: queryArg.serviceItemId},
      ],
      extraOptions: {
        responseSchema: PatchServiceMaterialItemIntegrationClaraInformationApiResponseSchema,
        requestSchema: PatchServiceMaterialItemIntegrationClaraInformationApiArgSchema,
      },
    }),
    getServiceJobIntegrationXentryInformation: build.query<
      GetServiceJobIntegrationXentryInformationApiResponse,
      GetServiceJobIntegrationXentryInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/integration/xentry-additional-information`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceOrderId},
        {type: 'orderIntegration', id: queryArg.serviceJobId},
      ],
      extraOptions: {
        responseSchema: GetServiceJobIntegrationXentryInformationApiResponseSchema,
        requestSchema: GetServiceJobIntegrationXentryInformationApiArgSchema,
      },
    }),
    patchServiceJobIntegrationXentryInformation: build.mutation<
      PatchServiceJobIntegrationXentryInformationApiResponse,
      PatchServiceJobIntegrationXentryInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/integration/xentry-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'orderIntegration', id: queryArg.serviceJobId},
        {type: 'serviceCase', id: queryArg.serviceCaseId},
        {type: 'serviceOrders', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: PatchServiceJobIntegrationXentryInformationApiResponseSchema,
        requestSchema: PatchServiceJobIntegrationXentryInformationApiArgSchema,
      },
    }),
    getIntegrationCustomer: build.query<
      GetIntegrationCustomerApiResponse,
      GetIntegrationCustomerApiArg
    >({
      query: (queryArg) => ({
        headers: {
          Accept: 'application/pdf',
        },
        url: `/integration/v1/integration/${queryArg.customerId}`,
        responseHandler: async (response) => {
          const contentType = response.headers.get('content-type')?.toLowerCase();
          if (isNil(contentType) || !contentType.startsWith('application/pdf')) {
            return null;
          }
          const blob = await response.blob();
          return blob.size
            ? window.URL.createObjectURL(new Blob([blob], {type: 'application/pdf'}))
            : null;
        },
      }),
      keepUnusedDataFor: 0, // Disable cache for PDF data
      extraOptions: {
        responseSchema: GetIntegrationCustomerApiResponseSchema,
        requestSchema: GetIntegrationCustomerApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsXentrySynchronizationStatus: build.query<
      GetServiceCaseIntegrationsXentrySynchronizationStatusApiResponse,
      GetServiceCaseIntegrationsXentrySynchronizationStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v2/service-case/${queryArg.serviceCaseId}/integration/xentry-synchronization-status`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsXentrySynchronizationStatusApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsXentrySynchronizationStatusApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsEvaClaimDetail: build.query<
      GetServiceCaseIntegrationsEvaClaimDetailApiResponse,
      GetServiceCaseIntegrationsEvaClaimDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/eva-claim`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'evaClaimDetail', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsEvaClaimDetailApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsEvaClaimDetailApiArgSchema,
      },
    }),
    postServiceCaseIntegrationsEvaClaimExport: build.mutation<
      PostServiceCaseIntegrationsEvaClaimExportApiResponse,
      PostServiceCaseIntegrationsEvaClaimExportApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/integration/eva-claim-export`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'evaClaimDetail', id: queryArg.serviceCaseId},
        {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
      ],
      extraOptions: {
        responseSchema: PostServiceCaseIntegrationsEvaClaimExportApiResponseSchema,
        requestSchema: PostServiceCaseIntegrationsEvaClaimExportApiArgSchema,
      },
    }),
    getServiceCaseIntegrationsEvaClaimAdditionalInformation: build.query<
      GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
      GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/eva-additional-information`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'evaClaimAdditionalInformation',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponseSchema,
        requestSchema: GetServiceCaseIntegrationsEvaClaimAdditionalInformationApiArgSchema,
      },
    }),
    patchServiceCaseIntegrationsEvaClaimAdditionalInformation: build.mutation<
      PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponse,
      PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/eva-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {
          type: 'evaClaimAdditionalInformation',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiResponseSchema,
        requestSchema: PatchServiceCaseIntegrationsEvaClaimAdditionalInformationApiArgSchema,
      },
    }),
    getServiceOrderIntegrationsMazdaAdditionalInformation: build.query<
      GetServiceOrderIntegrationsMazdaAdditionalInformationApiResponse,
      GetServiceOrderIntegrationsMazdaAdditionalInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-additional-information`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'mazdaAdditionalInformation',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: GetServiceOrderIntegrationsMazdaAdditionalInformationApiResponseSchema,
        requestSchema: GetServiceOrderIntegrationsMazdaAdditionalInformationApiArgSchema,
      },
    }),
    patchServiceOrderIntegrationsMazdaAdditionalInformation: build.mutation<
      PatchServiceOrderIntegrationsMazdaAdditionalInformationApiResponse,
      PatchServiceOrderIntegrationsMazdaAdditionalInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: PatchServiceOrderIntegrationsMazdaAdditionalInformationApiArg) => [
          {
            type: 'mazdaAdditionalInformation',
            id: queryArg.serviceOrderId,
          },
        ]
      ),
      extraOptions: {
        responseSchema: PatchServiceOrderIntegrationsMazdaAdditionalInformationApiResponseSchema,
        requestSchema: PatchServiceOrderIntegrationsMazdaAdditionalInformationApiArgSchema,
      },
    }),
    getServiceWorkItemIntegrationsMazdaAdditionalInformation: build.query<
      GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponse,
      GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-work/${queryArg.serviceItemId}/integration/mazda-additional-information`,
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'workItemMazdaAdditionalInformation',
          id: queryArg.serviceItemId,
        },
      ],
      extraOptions: {
        responseSchema: GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponseSchema,
        requestSchema: GetServiceWorkItemIntegrationsMazdaAdditionalInformationApiArgSchema,
      },
    }),
    patchServiceWorkItemIntegrationsMazdaAdditionalInformation: build.mutation<
      PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponse,
      PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/job/${queryArg.serviceJobId}/item-work/${queryArg.serviceItemId}/integration/mazda-additional-information`,
        method: 'PATCH',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiArg) => [
          {
            type: 'workItemMazdaAdditionalInformation',
            id: queryArg.serviceItemId,
          },
        ]
      ),
      extraOptions: {
        responseSchema: PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiResponseSchema,
        requestSchema: PatchServiceWorkItemIntegrationsMazdaAdditionalInformationApiArgSchema,
      },
    }),
    getServiceOrderIntegrationsMazdaPreauthorizationDetail: build.query<
      GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiResponse,
      GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-preauthorization-detail`,
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'mazdaPreauthorization',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiResponseSchema,
        requestSchema: GetServiceOrderIntegrationsMazdaPreauthorizationDetailApiArgSchema,
      },
    }),
    getServiceOrderIntegrationsMazdaPreauthorization: build.query<
      GetServiceOrderIntegrationsMazdaPreauthorizationApiResponse,
      GetServiceOrderIntegrationsMazdaPreauthorizationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-preauthorization`,
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'mazdaPreauthorization',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: GetServiceOrderIntegrationsMazdaPreauthorizationApiResponseSchema,
        requestSchema: GetServiceOrderIntegrationsMazdaPreauthorizationApiArgSchema,
      },
    }),
    putServiceOrderIntegrationsMazdaPreauthorization: build.mutation<
      PutServiceOrderIntegrationsMazdaPreauthorizationApiResponse,
      PutServiceOrderIntegrationsMazdaPreauthorizationApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-preauthorization`,
        method: 'PUT',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: PutServiceOrderIntegrationsMazdaPreauthorizationApiArg) => [
          {
            type: 'mazdaPreauthorization',
            id: queryArg.serviceOrderId,
          },
        ]
      ),
      extraOptions: {
        responseSchema: PutServiceOrderIntegrationsMazdaPreauthorizationApiResponseSchema,
        requestSchema: PutServiceOrderIntegrationsMazdaPreauthorizationApiArgSchema,
      },
    }),
    postServiceOrderIntegrationsMazdaPreauthorizationSend: build.mutation<
      PostServiceOrderIntegrationsMazdaPreauthorizationSendApiResponse,
      PostServiceOrderIntegrationsMazdaPreauthorizationSendApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-preauthorization/send`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: PostServiceOrderIntegrationsMazdaPreauthorizationSendApiArg) => [
          {type: 'mazdaPreauthorization', id: queryArg.serviceOrderId},
          {type: 'orderIntegration', id: queryArg.serviceOrderId},
          {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        ]
      ),
      extraOptions: {
        responseSchema: PostServiceOrderIntegrationsMazdaPreauthorizationSendApiResponseSchema,
        requestSchema: PostServiceOrderIntegrationsMazdaPreauthorizationSendApiArgSchema,
      },
    }),
    getServiceOrderIntegrationsMazdaClaim: build.query<
      GetServiceOrderIntegrationsMazdaClaimApiResponse,
      GetServiceOrderIntegrationsMazdaClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-claim`,
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'mazdaClaim',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: GetServiceOrderIntegrationsMazdaClaimApiResponseSchema,
        requestSchema: GetServiceOrderIntegrationsMazdaClaimApiArgSchema,
      },
    }),
    putServiceOrderIntegrationsMazdaClaim: build.mutation<
      PutServiceOrderIntegrationsMazdaClaimApiResponse,
      PutServiceOrderIntegrationsMazdaClaimApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-claim`,
        method: 'PUT',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: PutServiceOrderIntegrationsMazdaClaimApiArg) => [
          {
            type: 'mazdaClaim',
            id: queryArg.serviceOrderId,
          },
        ]
      ),
      extraOptions: {
        responseSchema: PutServiceOrderIntegrationsMazdaClaimApiResponseSchema,
        requestSchema: PutServiceOrderIntegrationsMazdaClaimApiArgSchema,
      },
    }),
    postServiceOrderIntegrationsMazdaClaimSend: build.mutation<
      PostServiceOrderIntegrationsMazdaClaimSendApiResponse,
      PostServiceOrderIntegrationsMazdaClaimSendApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-claim/send`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: PostServiceOrderIntegrationsMazdaClaimSendApiArg) => [
          {type: 'mazdaClaim', id: queryArg.serviceOrderId},
          {type: 'orderIntegration', id: queryArg.serviceOrderId},
          {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        ]
      ),
      extraOptions: {
        responseSchema: PostServiceOrderIntegrationsMazdaClaimSendApiResponseSchema,
        requestSchema: PostServiceOrderIntegrationsMazdaClaimSendApiArgSchema,
      },
    }),
    getServiceOrderIntegrationsMazdaClaimDetail: build.query<
      GetServiceOrderIntegrationsMazdaClaimDetailApiResponse,
      GetServiceOrderIntegrationsMazdaClaimDetailApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/service-case/${queryArg.serviceCaseId}/order/${queryArg.serviceOrderId}/integration/mazda-claim-detail`,
        queryArg,
      }),
      providesTags: (_result, _error, queryArg) => [
        {
          type: 'mazdaClaim',
          id: queryArg.serviceOrderId,
        },
      ],
      extraOptions: {
        responseSchema: GetServiceOrderIntegrationsMazdaClaimDetailApiResponseSchema,
        requestSchema: GetServiceOrderIntegrationsMazdaClaimDetailApiArgSchema,
      },
    }),
    getVehicleServiceChecklists: build.query<
      GetVehicleServiceChecklistsApiResponse,
      GetVehicleServiceChecklistsApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/vehicle/${queryArg.vehicleId}/service-checklists`,
        queryArg,
      }),
      // Deliberately untagged — the list is resolved live from Mazda per VIN and a definition
      // disappears once its checklist is open, so consumers must force a refetch on mount.
      extraOptions: {
        responseSchema: GetVehicleServiceChecklistsApiResponseSchema,
        requestSchema: GetVehicleServiceChecklistsApiArgSchema,
      },
    }),
    postVehicleServiceChecklist: build.mutation<
      PostVehicleServiceChecklistApiResponse,
      PostVehicleServiceChecklistApiArg
    >({
      query: (queryArg) => ({
        url: `/service/v1/vehicle/${queryArg.vehicleId}/service-checklists`,
        method: 'POST',
        body: queryArg.body,
        queryArg,
      }),
      invalidatesTags: invalidateOnSuccess(
        (_result, queryArg: PostVehicleServiceChecklistApiArg) => [
          {type: 'orderIntegration', id: queryArg.body.serviceOrderId},
          {type: 'serviceCaseIntergations', id: queryArg.serviceCaseId},
        ]
      ),
      extraOptions: {
        responseSchema: PostVehicleServiceChecklistApiResponseSchema,
        requestSchema: PostVehicleServiceChecklistApiArgSchema,
      },
    }),
  }),
});

export const {
  usePostIntegrationsForXentryLinkMutation,
  usePostIntegrationsForXentryUnlinkMutation,
  usePostAvailableXentryOrdersMutation,
  useGetServiceCaseIntegrationsQuery,
  usePostServiceOrderAudatexTaskCalculationsMutation,
  usePostServiceOrderMyClaimCalculationsMutation,
  usePostServiceCaseIntegrationsXentryOrderManualCreationMutation,
  usePostServiceCaseIntegrationsXentryOrderSynchronizationApiMutation,
  useGetAudatexCalculationsUserSettingsQuery,
  useGetMyClaimCalculationsUserSettingsQuery,
  useGetServiceCaseIntegrationsClaraVehicleDetailsQuery,
  useGetServiceCaseIntegrationsClaraClaimQuery,
  usePostServiceCaseIntegrationsClaraClaimMutation,
  useGetServiceCaseIntegrationsClaraClaimDetailQuery,
  useGetServiceOrderIntegrationClaraInformationQuery,
  usePatchServiceOrderIntegrationClaraInformationMutation,
  useGetServiceWorkItemIntegrationClaraInformationQuery,
  usePatchServiceWorkItemIntegrationClaraInformationMutation,
  useGetServiceMaterialItemIntegrationClaraInformationQuery,
  usePatchServiceMaterialItemIntegrationClaraInformationMutation,
  useGetServiceJobIntegrationXentryInformationQuery,
  usePatchServiceJobIntegrationXentryInformationMutation,
  useGetIntegrationCustomerQuery,
  useGetServiceCaseIntegrationsXentrySynchronizationStatusQuery,
  useGetServiceCaseIntegrationsEvaClaimDetailQuery,
  usePostServiceCaseIntegrationsEvaClaimExportMutation,
  useGetServiceCaseIntegrationsEvaClaimAdditionalInformationQuery,
  usePatchServiceCaseIntegrationsEvaClaimAdditionalInformationMutation,
  useGetServiceOrderIntegrationsMazdaAdditionalInformationQuery,
  usePatchServiceOrderIntegrationsMazdaAdditionalInformationMutation,
  useGetServiceWorkItemIntegrationsMazdaAdditionalInformationQuery,
  usePatchServiceWorkItemIntegrationsMazdaAdditionalInformationMutation,
  useGetServiceOrderIntegrationsMazdaPreauthorizationDetailQuery,
  useGetServiceOrderIntegrationsMazdaPreauthorizationQuery,
  usePutServiceOrderIntegrationsMazdaPreauthorizationMutation,
  usePostServiceOrderIntegrationsMazdaPreauthorizationSendMutation,
  useLazyGetServiceOrderIntegrationsMazdaPreauthorizationQuery,
  useGetServiceOrderIntegrationsMazdaClaimQuery,
  usePutServiceOrderIntegrationsMazdaClaimMutation,
  usePostServiceOrderIntegrationsMazdaClaimSendMutation,
  useGetServiceOrderIntegrationsMazdaClaimDetailQuery,
  useGetVehicleServiceChecklistsQuery,
  usePostVehicleServiceChecklistMutation,
} = metadaWorkshopIntegrationApi;
